// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

let values = [
  "INDEPENDENT",
  "AFFILIATED",
  "FRANCHISED",
  "INTEGRATED",
  "WAREHOUSE"
];

function toLabel(value) {
  if (value === "WAREHOUSE") {
    return I18n.t("Warehouse");
  } else if (value === "INTEGRATED") {
    return I18n.t("Integrated");
  } else if (value === "INDEPENDENT") {
    return I18n.t("Independent");
  } else if (value === "AFFILIATED") {
    return I18n.t("Affiliated");
  } else {
    return I18n.t("Franchised");
  }
}

function toString(value) {
  return value;
}

function fromString(value) {
  return values.find(current => current === value);
}

function toStyleSet(value) {
  if (value === "WAREHOUSE") {
    return {
      bgColor: "#E7E7EE",
      textColor: "#25243A",
      borderColor: "#A2A1B0"
    };
  } else if (value === "INTEGRATED") {
    return {
      bgColor: "#EDE9FE",
      textColor: "#4C1D95",
      borderColor: "#C4B5FD"
    };
  } else if (value === "INDEPENDENT") {
    return {
      bgColor: "#FBE8F8",
      textColor: "#4D0A35",
      borderColor: "#F6ABE6"
    };
  } else if (value === "AFFILIATED") {
    return {
      bgColor: "#FFF5C6",
      textColor: "#7A360D",
      borderColor: "#FFD84A"
    };
  } else {
    return {
      bgColor: "#FFE5CF",
      textColor: "#7C2112",
      borderColor: "#FDAB74"
    };
  }
}

let make = React.memo(props => {
  let __size = props.size;
  let value = props.value;
  let size = __size !== undefined ? __size : "medium";
  let styleSet = toStyleSet(value);
  return JsxRuntime.jsx(Badge.make, {
    children: toLabel(value),
    size: size,
    borderColor: styleSet.borderColor,
    backgroundColor: styleSet.bgColor,
    foregroundColor: styleSet.textColor
  });
});

let Badge$1 = {
  toStyleSet: toStyleSet,
  make: make
};

let ShopKind = {
  values: values,
  toLabel: toLabel,
  toString: toString,
  fromString: fromString,
  Badge: Badge$1
};

export {
  ShopKind,
}
/* make Not a pure module */
